module.exports = __webpack_public_path__ + "static/media/small-field.fcdea8b1.PNG";